import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faPlus, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    DailySafetyCoordinationMeeting,
    DailySafetyEmployeeSignature,
    DailySafetyLearnedEmployee,
    DailySafetyMeetingTask,
    FeatureType,
    ListItem,
    RepositoryModal,
} from '../../shared'
import { VoiceTextFieldComponent } from '../../shared/components/voice-text-field/voice-text-field.component'
import { DailySafetyCoordinationMeetingsComponent } from './daily-safety-coordination-meetings.component'

@Component({
    templateUrl: './daily-safety-coordination-meeting.component.html',
    styleUrls: ['./safety-checklist-modal.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent, VoiceTextFieldComponent],
})
export class DailySafetyCoordinationMeetingComponent extends RepositoryModal<DailySafetyCoordinationMeeting> {
    faPlus = faPlus
    faTrash = faTrash
    faSpinner = faSpinner

    jobList: ListItem<string>[] = []
    employeeList: ListItem<number>[] = []

    protected onInitialized(): void {
        const parent = this.editOptions.initializeParams as DailySafetyCoordinationMeetingsComponent
        this.jobList = [...(parent.activeJobList ?? [])]
        this.employeeList = [...(parent.activeEmployeeList ?? [])]

        const currentJob = this.target.job
        if (currentJob && !this.jobList.some(j => j.value === currentJob)) {
            this.jobList = [new ListItem(currentJob, parent.jobDisplayForItem(currentJob) || currentJob), ...this.jobList]
        }

        this.target.learnedEmployees = this.target.learnedEmployees ?? []
        this.target.tasks = this.target.tasks ?? []
        this.target.employeeSignatures = this.target.employeeSignatures ?? []

        const hrRefs = [
            this.target.acknowledgedEmployeeHrRef,
            ...this.target.learnedEmployees.map(x => x.employeeHrRef),
            ...this.target.tasks.map(x => x.employeeHrRef),
        ]
        for (const hrRef of hrRefs) {
            this.ensureEmployeeOption(hrRef, parent)
        }
    }

    get canEdit(): boolean {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }

    addLearnedEmployee() {
        const row = new DailySafetyLearnedEmployee()
        row.id = crypto.randomUUID()
        row.sortOrder = this.target.learnedEmployees.length
        this.target.learnedEmployees.push(row)
    }

    removeLearnedEmployee(index: number) {
        this.target.learnedEmployees.splice(index, 1)
        this.target.learnedEmployees.forEach((row, i) => (row.sortOrder = i))
    }

    addTask() {
        const row = new DailySafetyMeetingTask()
        row.id = crypto.randomUUID()
        row.sortOrder = this.target.tasks.length
        this.target.tasks.push(row)
    }

    removeTask(index: number) {
        this.target.tasks.splice(index, 1)
        this.target.tasks.forEach((row, i) => (row.sortOrder = i))
    }

    addSignature() {
        const row = new DailySafetyEmployeeSignature()
        row.id = crypto.randomUUID()
        row.sortOrder = this.target.employeeSignatures.length
        this.target.employeeSignatures.push(row)
    }

    removeSignature(index: number) {
        this.target.employeeSignatures.splice(index, 1)
        this.target.employeeSignatures.forEach((row, i) => (row.sortOrder = i))
    }

    private ensureEmployeeOption(hrRef: number | null | undefined, parent: DailySafetyCoordinationMeetingsComponent) {
        if (hrRef == null || this.employeeList.some(e => e.value === hrRef)) return
        const inactive = parent.allEmployees.find(u => u.id === hrRef)
        const label = inactive ? `${inactive.name} (inactive)` : `${hrRef} (inactive)`
        this.employeeList = [new ListItem(hrRef, label), ...this.employeeList]
    }
}
